// extracted by mini-css-extract-plugin
export default {"linkCopied":"linkCopied_linkCopied__Bj8jP"};